import { modularScale } from "polished";
import { theme } from "@chakra-ui/react";

/* eslint-disable sort-keys, no-magic-numbers */
import { TEN, measure, ratio, s0 } from "./constants";

export const baseSizes = {
    "s-5": `${modularScale(-5, s0, ratio)}rem`,
    "s-4": `${modularScale(-4, s0, ratio)}rem`,
    "s-3": `${modularScale(-3, s0, ratio)}rem`,
    "s-2": `${modularScale(-2, s0, ratio)}rem`,
    "s-1": `${modularScale(-1, s0, ratio)}rem`,
    "s0": `${modularScale(0, s0, ratio)}rem`,
    "s1": `${modularScale(1, s0, ratio)}rem`,
    "s2": `${modularScale(2, s0, ratio)}rem`,
    "s3": `${modularScale(3, s0, ratio)}rem`,
    "s4": `${modularScale(4, s0, ratio)}rem`,
    "s5": `${modularScale(5, s0, ratio)}rem`,
};

// Sizes where each step = 0.25rem (4px), including half steps up to 100
// Calculated with Object.fromEntries([ ...R.range(0,100),...R.range(0,100).map(i => i + 0.5)].sort().map(i => [`${i}`, `${0.25*i}rem`]))
const base4sizes = {
    px: "1px",
    0: "0rem",
    1: "0.25rem",
    2: "0.5rem",
    3: "0.75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    11: "2.75rem",
    12: "3rem",
    13: "3.25rem",
    14: "3.5rem",
    15: "3.75rem",
    16: "4rem",
    17: "4.25rem",
    18: "4.5rem",
    19: "4.75rem",
    20: "5rem",
    21: "5.25rem",
    22: "5.5rem",
    23: "5.75rem",
    24: "6rem",
    25: "6.25rem",
    26: "6.5rem",
    27: "6.75rem",
    28: "7rem",
    29: "7.25rem",
    30: "7.5rem",
    31: "7.75rem",
    32: "8rem",
    33: "8.25rem",
    34: "8.5rem",
    35: "8.75rem",
    36: "9rem",
    37: "9.25rem",
    38: "9.5rem",
    39: "9.75rem",
    40: "10rem",
    41: "10.25rem",
    42: "10.5rem",
    43: "10.75rem",
    44: "11rem",
    45: "11.25rem",
    46: "11.5rem",
    47: "11.75rem",
    48: "12rem",
    49: "12.25rem",
    50: "12.5rem",
    51: "12.75rem",
    52: "13rem",
    53: "13.25rem",
    54: "13.5rem",
    55: "13.75rem",
    56: "14rem",
    57: "14.25rem",
    58: "14.5rem",
    59: "14.75rem",
    60: "15rem",
    61: "15.25rem",
    62: "15.5rem",
    63: "15.75rem",
    64: "16rem",
    65: "16.25rem",
    66: "16.5rem",
    67: "16.75rem",
    68: "17rem",
    69: "17.25rem",
    70: "17.5rem",
    71: "17.75rem",
    72: "18rem",
    73: "18.25rem",
    74: "18.5rem",
    75: "18.75rem",
    76: "19rem",
    77: "19.25rem",
    78: "19.5rem",
    79: "19.75rem",
    80: "20rem",
    81: "20.25rem",
    82: "20.5rem",
    83: "20.75rem",
    84: "21rem",
    85: "21.25rem",
    86: "21.5rem",
    87: "21.75rem",
    88: "22rem",
    89: "22.25rem",
    90: "22.5rem",
    91: "22.75rem",
    92: "23rem",
    93: "23.25rem",
    94: "23.5rem",
    95: "23.75rem",
    96: "24rem",
    97: "24.25rem",
    98: "24.5rem",
    99: "24.75rem",
    0.5: "0.125rem",
    1.5: "0.375rem",
    10.5: "2.625rem",
    11.5: "2.875rem",
    12.5: "3.125rem",
    13.5: "3.375rem",
    14.5: "3.625rem",
    15.5: "3.875rem",
    16.5: "4.125rem",
    17.5: "4.375rem",
    18.5: "4.625rem",
    19.5: "4.875rem",
    2.5: "0.625rem",
    20.5: "5.125rem",
    21.5: "5.375rem",
    22.5: "5.625rem",
    23.5: "5.875rem",
    24.5: "6.125rem",
    25.5: "6.375rem",
    26.5: "6.625rem",
    27.5: "6.875rem",
    28.5: "7.125rem",
    29.5: "7.375rem",
    3.5: "0.875rem",
    30.5: "7.625rem",
    31.5: "7.875rem",
    32.5: "8.125rem",
    33.5: "8.375rem",
    34.5: "8.625rem",
    35.5: "8.875rem",
    36.5: "9.125rem",
    37.5: "9.375rem",
    38.5: "9.625rem",
    39.5: "9.875rem",
    4.5: "1.125rem",
    40.5: "10.125rem",
    41.5: "10.375rem",
    42.5: "10.625rem",
    43.5: "10.875rem",
    44.5: "11.125rem",
    45.5: "11.375rem",
    46.5: "11.625rem",
    47.5: "11.875rem",
    48.5: "12.125rem",
    49.5: "12.375rem",
    5.5: "1.375rem",
    50.5: "12.625rem",
    51.5: "12.875rem",
    52.5: "13.125rem",
    53.5: "13.375rem",
    54.5: "13.625rem",
    55.5: "13.875rem",
    56.5: "14.125rem",
    57.5: "14.375rem",
    58.5: "14.625rem",
    59.5: "14.875rem",
    6.5: "1.625rem",
    60.5: "15.125rem",
    61.5: "15.375rem",
    62.5: "15.625rem",
    63.5: "15.875rem",
    64.5: "16.125rem",
    65.5: "16.375rem",
    66.5: "16.625rem",
    67.5: "16.875rem",
    68.5: "17.125rem",
    69.5: "17.375rem",
    7.5: "1.875rem",
    70.5: "17.625rem",
    71.5: "17.875rem",
    72.5: "18.125rem",
    73.5: "18.375rem",
    74.5: "18.625rem",
    75.5: "18.875rem",
    76.5: "19.125rem",
    77.5: "19.375rem",
    78.5: "19.625rem",
    79.5: "19.875rem",
    8.5: "2.125rem",
    80.5: "20.125rem",
    81.5: "20.375rem",
    82.5: "20.625rem",
    83.5: "20.875rem",
    84.5: "21.125rem",
    85.5: "21.375rem",
    86.5: "21.625rem",
    87.5: "21.875rem",
    88.5: "22.125rem",
    89.5: "22.375rem",
    9.5: "2.375rem",
    90.5: "22.625rem",
    91.5: "22.875rem",
    92.5: "23.125rem",
    93.5: "23.375rem",
    94.5: "23.625rem",
    95.5: "23.875rem",
    96.5: "24.125rem",
    97.5: "24.375rem",
    98.5: "24.625rem",
    99.5: "24.875rem",
    144: "36rem"
};


export const space = {
    none: "0px",
    hair: "1.5px",
    doublehair: "3px",
    xxsmall: `${modularScale(3, s0 / TEN, ratio)}rem`,
    xsmall: `${modularScale(4, s0 / TEN, ratio)}rem`,
    small: `${modularScale(6, s0 / TEN, ratio)}rem`,
    medium: `${modularScale(8, s0 / TEN, ratio)}rem`,
    large: `${modularScale(10, s0 / TEN, ratio)}rem`,
    xlarge: `${modularScale(12, s0 / TEN, ratio)}rem`,
    horizontal: `${modularScale(1.75, s0, ratio)} rem`,
    vertical: `${modularScale(2.2, s0 / 5, ratio)} rem`,
};
export const altSpace = {
    xxs: space.xxsmall,
    xs: space.xsmall,
    sm: space.small,
    md: space.medium,
    lg: space.large,
    xl: space.xlarge,
    xxl: theme.space["64"]
};

export const sizes = {
    ...theme.sizes,
    ...base4sizes, 
    xxsmall: `${modularScale(0, measure / TEN, ratio)}ch`,
    xsmall: `${modularScale(1, measure / TEN, ratio)}ch`,
    // smallXsmall is halfway between xsmall and small
    smallXsmall: "350px",
    small: `${modularScale(2, measure / TEN, ratio)}ch`,
    medium: `${modularScale(5, measure / TEN, ratio)}ch`,
    large: `${modularScale(7, measure / TEN, ratio)}ch`,
    xlarge: `${modularScale(8, measure / TEN, ratio)}ch`,
    xxlarge: `${modularScale(9, measure / TEN, ratio)}ch`,
    full: "100%",
    half: "50%",
    twothird: "calc(100%/3*2)",
    third: "calc(100%/3)",
    view: "100vw",
    normal: `${measure}ch`,
    // 120ch - somewhere between large (~100ch) and xlarge (~150ch)
    doubleNormal: `${measure*2}ch`,

};
export const fontSizes = {
    "h1": "2.25rem", // 36px
    "h2": "1.875rem", // 30px
    "h3": "1.25rem", // 20px
    "h3.5": "1.125rem",
    "h4": "1rem", // 16px
    "h5": "1rem", // 16px
    "p1": "1rem", // 16px
    "p2": "0.875rem", // 14px
    "p3": "0.75rem", // 12px
    "p4": "0.6875rem", // 11px,
};
export const lineHeights = {};
export const letterSpacings = {};

export default {
    space: {
        ...baseSizes,
        ...theme.space,
        ...base4sizes,
        ...altSpace,
        ...space,
    },
    sizes: {
        ...baseSizes,
        ...sizes
    },
    fontSizes: {
        ...baseSizes,
        ...theme.fontSizes,
        ...fontSizes
    },
    lineHeights: {
        ...baseSizes,
        ...theme.lineHeights,
        ...base4sizes,
        ...lineHeights
    },
    letterSpacings: {
        ...theme.letterSpacings,
        ...letterSpacings
    },
};
